import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { APP_STATE_KEY, AppState } from '../state';

export const selectAppState: MemoizedSelector<object, AppState> =
  createFeatureSelector<AppState>(APP_STATE_KEY);

// eslint-disable-next-line @typescript-eslint/typedef
export const selectMainNavigation = createSelector(
  selectAppState,
  (state: AppState) => state.mainNavigation.data,
);
